import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '/images/about/fixed_a.png'
import _imports_1 from '/images/about/fixed_k.png'


const _hoisted_1 = { class: "flex flex-col md:flex-row gap-10 p-5 justify-center w-full items-center mb-10" }
const _hoisted_2 = { class: "flex justify-center" }
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-6 ps-5 px-4 justify-center w-full h-auto items-center mb-10 mt-10" }
const _hoisted_4 = { class: "flex flex-col gap-6 leading-relaxed" }
const _hoisted_5 = { class: "flex flex-col md:flex-row lg:flex-row items-center gap-4" }
const _hoisted_6 = { class: "bg-primary-200 rounded-full p-4 h-16 w-16 flex justify-center align-middle items-center" }
const _hoisted_7 = { class: "flex flex-col md:flex-row lg:flex-row items-center gap-4" }
const _hoisted_8 = { class: "bg-primary-200 rounded-full p-4 h-16 w-16 flex justify-center align-middle items-center" }
const _hoisted_9 = { class: "flex flex-col md:flex-row lg:flex-row items-center gap-4" }
const _hoisted_10 = { class: "bg-primary-200 rounded-full p-4 h-16 w-16 flex justify-center align-middle items-center" }
const _hoisted_11 = { class: "flex justify-center" }


export default /*@__PURE__*/_defineComponent({
  __name: 'about',
  setup(__props) {

// ? NEED TO add contact form logic
definePageMeta({
  layout: "default",
  pageTransition: { name: "page", mode: "out-in" },
});

useHead({
  title: "About Us - FamilyAxis",
  meta: [{ name: "description", content: "About FamilyAxis" }],
  bodyAttrs: {
    class: "about",
  },
});

defineOgImage("MainOg", {
  title: "About FamilyAxis",
  description: "Meet FamilyAxis — built by practitioners to streamline family assessments.",
  theme: "#bc9fff",
  colorMode: "light",
});

useSeoMeta({
  title: "About Us | FamilyAxis",
  description:
    "Learn about FamilyAxis: built by practitioners to streamline observations, reports, safeguarding, and operations for family assessment centres.",
  keywords:
    "about FamilyAxis, residential family assessment software, safeguarding, observations, reports, UK GDPR",
  author: "FamilyAxis",
  ogTitle: "About Us | FamilyAxis",
  ogDescription: "Discover the mission and team behind FamilyAxis.",
  ogUrl: "https://familyaxis.com/about",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "About Us | FamilyAxis",
  twitterDescription: "FamilyAxis helps residential family assessment centres streamline work.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

// Contact form state
const contactForm = reactive({
  company: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  message: "",
});

// Form validation state
const errors = ref<Record<string, string>>({});
const isSubmitting = ref(false);
const submitStatus = ref<null | "success" | "error">(null);
const statusMessage = ref("");

const authStore = useAuthStore();

// Form validation
const validateForm = () => {
  const newErrors: Record<string, string> = {};

  // Company is optional

  if (!contactForm.firstName.trim()) {
    newErrors.firstName = "First name is required";
  }

  if (!contactForm.lastName.trim()) {
    newErrors.lastName = "Last name is required";
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!contactForm.email.trim()) {
    newErrors.email = "Email is required";
  } else if (!emailRegex.test(contactForm.email)) {
    newErrors.email = "Please enter a valid email";
  }

  // Phone is optional but validate if provided
  if (contactForm.phone.trim() && !/^[0-9+\-\s()]+$/.test(contactForm.phone)) {
    newErrors.phone = "Please enter a valid phone number";
  }

  if (!contactForm.message.trim()) {
    newErrors.message = "Message is required";
  }

  errors.value = newErrors;
  return Object.keys(newErrors).length === 0;
};

// Form submission
const submitForm = async () => {
  if (!validateForm()) {
    return;
  }

  isSubmitting.value = true;
  submitStatus.value = null;
  statusMessage.value = "";

  try {
    const payload = {
      companyName: contactForm.company,
      firstName: contactForm.firstName,
      lastName: contactForm.lastName,
      email: contactForm.email,
      phone: contactForm.phone,
      message: contactForm.message,
    };

    await authStore.api("POST", "/contact/form", payload);

    submitStatus.value = "success";
    statusMessage.value = "Your message has been sent successfully!";
    // Reset form after successful submission
    Object.keys(contactForm).forEach((key) => {
      contactForm[key as keyof typeof contactForm] = "";
    });
  } catch (error) {
    submitStatus.value = "error";
    statusMessage.value =
      error.message || "An error occurred while submitting the form. Please try again.";
    console.error("Contact form submission error:", error);
  } finally {
    isSubmitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_LottieWrapper = _resolveComponent("LottieWrapper")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_NuxtImg = _resolveComponent("NuxtImg")!
  const _component_UPageBody = _resolveComponent("UPageBody")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, null, {
        default: _withCtx(() => [
          _createVNode(_component_UPageBody, { class: "pt-16 pb-20" }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "font-bold capitalize text-2xl text-(--ui-primary) w-full align-middle flex justify-center" }, " OUR STORY ", -1)),
              _createElementVNode("div", _hoisted_1, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex flex-col gap-4 leading-relaxed" }, [
                  _createElementVNode("p", null, " At FamilyAxis, we understand the unique challenges faced by family assessment services because we've been there. As a former family assessment practitioner, I experienced first hand the frustrations of working with outdated and generic software that took time away from supporting families. "),
                  _createElementVNode("p", null, " Motivated by this, I partnered with a leading software developer and digital artist to create FamilyAxis - a modern solution designed to streamline tasks, improve efficiency, and let staff focus on what matters: helping families to thrive. "),
                  _createElementVNode("p", null, " FamilyAxis is more than just software - it’s a solution built with the insight of someone who knows the demands of this field and the importance of doing it right. By integrating modern technology and user-friendly tools, we aim to make family assessments easier, more effective, and focused on delivering the best outcomes for families and children. ")
                ], -1)),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_LottieWrapper, {
                    "animation-link": "/animations/young_family.json",
                    class: "w-full h-full",
                    loop: true,
                    speed: 1.0,
                    scale: 1
                  })
                ])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-4xl font-bold tracking-tight p-6 pt-15 pb-15 text-center" }, " The fundamental principles guiding our company ", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "font-bold capitalize text-2xl text-(--ui-primary) text-center w-full pt-10 pb-10" }, " OUR CULTURE ", -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_UIcon, {
                        name: "i-mdi:human-male-child",
                        class: "w-12 h-12 text-(--ui-primary)-500 dark:text-white"
                      })
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("div", null, [
                      _createElementVNode("h3", { class: "font-bold text-lg" }, "Tailored for Family Assessment Centres"),
                      _createElementVNode("p", null, " We recognise that one size doesn’t fit all. That’s why our software is built specifically for residential family centres to address their unique challenges. We put parents and children at the heart of our design, ensuring their needs and wishes are prioritised. ")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_UIcon, {
                        name: "i-heroicons-light-bulb",
                        class: "w-12 h-12 text-(--ui-primary)-500 dark:text-white"
                      })
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("div", null, [
                      _createElementVNode("h3", { class: "font-bold text-lg" }, "Built for Compliance, Backed by Standards"),
                      _createElementVNode("p", null, " We know how important it is to meet rigorous compliance and court evidence standards. That’s why FamilyAxis has considered the latest legal requirements and best practices to ensure that every observation, report and safeguarding entry meets the highest level of scrutiny. ")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_UIcon, {
                        name: "i-clarity:shield-check-line",
                        class: "w-12 h-12 text-(--ui-primary)-500 dark:text-white"
                      })
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                      _createElementVNode("h3", { class: "font-bold text-lg" }, "Simple, Intuitive, Powerful"),
                      _createElementVNode("p", null, " Technology should make your work easier, not harder. Our user-friendly interface is designed to be accessible to all levels of technical expertise. Whether you’re a tech novice or a digital pro, FamilyAxis provides the tools you need in a way that’s easy to understand and quick to master. ")
                    ], -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_NuxtImg, {
                    src: "/logo.svg",
                    alt: "Logo",
                    width: "1000",
                    height: "1000",
                    class: "h-automd:max-h-50 md:h-1/3"
                  })
                ])
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-4xl font-bold tracking-tight p-6 mt-15 mb-15 text-center" }, [
                _createElementVNode("span", null, "Meet the Minds Behind Family"),
                _createElementVNode("span", { class: "text-(--ui-primary)" }, "Axis")
              ], -1)),
              _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "font-bold capitalize text-2xl text-(--ui-primary) text-center w-full pt-10 pb-10" }, " FOUNDERS ", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex flex-col md:flex-row gap-6 justify-center align-middle w-full items-start" }, [
                _createElementVNode("div", { class: "flex flex-col gap-4 leading-relaxed items-center justify-center" }, [
                  _createElementVNode("div", { class: "relative p-4 h-[35rem] w-[25rem]" }, [
                    _createElementVNode("div", { class: "canvas rounded-3xl" }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      })
                    ])
                  ]),
                  _createElementVNode("h3", { class: "font-bold text-lg" }, "Anina Clarke"),
                  _createElementVNode("h3", { class: "text-md" }, "Founder & Managing Director")
                ]),
                _createElementVNode("div", { class: "flex flex-col gap-4 leading-relaxed items-center justify-center" }, [
                  _createElementVNode("div", { class: "relative p-4 w-[25rem] h-[35rem]" }, [
                    _createElementVNode("div", { class: "canvas rounded-3xl" }, [
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: ""
                      })
                    ])
                  ]),
                  _createElementVNode("h3", { class: "font-bold text-lg" }, "Kevin Niemeskern"),
                  _createElementVNode("h3", { class: "text-md" }, "Founder & Lead Developer")
                ])
              ], -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})